import { isSame } from '../utils';
export function dispatch(ctx, update) {
    const oldState = ctx.state.getState();
    const newState = update(oldState);
    if (!isSame(oldState, newState)) {
        ctx.state.setState(newState);
    }
}
export function readState(ctx, read) {
    return read(ctx.state.getState());
}
//# sourceMappingURL=state.js.map